export const getAccountTableColumns = ({
  tViews,
  onOverlaySelect,
  getOverlayActions,
  handleActionClick
}) => {
  const columns = [
    {
      prop: "org_name",
      id: "org_name",
      name: tViews('accountsOverlay'),
      sortable: true,
      size: 400,
      cellTemplate: (createElement, { model }) => {
        const overlayName = model?.org_name || "";
        const isActive = model?.status?.toLowerCase() === "active";
        const htmlContent = isActive
          ? `<div class="table-link" data-action="select-overlay" data-cy="${overlayName}" data-testid="${overlayName}">${overlayName}</div>`
          : `<div>${overlayName}</div>`;

        return createElement("div", {
          class: "flex-items",
          innerHTML: htmlContent,
          onClick: event => {
            if (event?.target?.dataset?.action === "select-overlay") {
              event.preventDefault();
              onOverlaySelect(model);
            }
          }
        });
      }
    },
    {
      prop: "status",
      id: "status",
      name: tViews('accountsOverlayStatus'),
      sortable: true,
      size: 200,
      cellTemplate: (createElement, { model }) => {
        const statusText = model.status === "INACTIVE"
          ? tViews('accountInactivePaused')
          : (model.status
            ? model.status.charAt(0).toUpperCase() + model.status.slice(1).toLowerCase()
            : "");
        return createElement("div", {
          class: "flex-items",
          innerHTML: `<div>${statusText}</div>`
        });
      }
    },
    {
      prop: "idp_defined",
      id: "idp_defined",
      name: tViews('accountsOverlayDefined'),
      sortable: true,
      size: 200,
      cellTemplate: (createElement, { model }) =>
        model.idp_defined === "False" ? tViews('accountNotDefined') : tViews('accountDefined')
    },
    {
      prop: "actions",
      id: "actions",
      name: tViews('accountsOverlayAction'),
      sortable: false,
      size: 320,
      cellTemplate: (createElement, props) => {
        const overlayActions = getOverlayActions(props.model);
        if (!overlayActions.length) {
          return createElement("div", {
            class: "flex-items",
            innerHTML: "<div></div>"
          });
        }

        const uniqueSeed = [
          props?.model?.overlay_id,
          props?.model?.va_id,
          props?.model?.org_name,
          props?.rowIndex
        ].filter(value => value !== undefined && value !== null && value !== "").join("-");
        const safeId = String(uniqueSeed || `row-${props?.rowIndex || 0}`)
          .replace(/[^a-zA-Z0-9_-]/g, "_");
        const id = `id-${safeId}`;
				const portal = createElement(
					"hbr-portal",
					{ target: "body" },
					createElement(
						"hbr-dropdown",
						{
							menu: true,
							anchor: `#action-${id}`,
							closeOnScroll: true,
							flipPadding: 10,
						},
						createElement("hbr-menu", {
							"onHbr-select": (e) => {
                handleActionClick(e?.detail?.item?.value, props.model);
							},
              innerHTML: overlayActions
                .map(action => `<hbr-menu-item value="${action.label}">${action.label}</hbr-menu-item>`)
                .join(""),
						}),
					),
				);
				const button = createElement("hbr-button", {
					id: `action-${id}`,
					variant: "text",
					innerHTML: `<hbr-icon name="more-horizontal" />`,
				});
				return createElement(
					"div",
					{
						style: { height: "100%", display: "flex", alignItems: "center" },
					},
					[button, portal],
				);
			}
    }
  ];

  for (const item of columns) {
    Object.assign(item, { id: item.prop });
  }

  return columns;
};
